import { getImageId } from '@gynzy/gatsby-source-storyblok';
import { formatUrl } from './url';

export const getImage = (imageUrl, images) => {
	const imageId = getImageId(imageUrl);
	return images.find(img => img.id === imageId)?.localFile;
};

export const extractOpenGraph = story => {
	const openGraph = {
		type: 'website',
		url: formatUrl(story.full_slug, true),
		title: story.content.metadata ? story.content.metadata.title : story.name,
		description: story.content.metadata?.description,
	};

	if (story.content.metadataImage?.filename && story.images) {
		const image = getImage(story.content.metadataImage.filename, story.images);
		if (image) {
			openGraph.images = [
				{
					url: formatUrl(image.publicURL, true, false),
					alt: image.alt,
				},
			];
		}
	}

	return openGraph;
};

export const extractMetadata = story => {
	if (!story) {
		return {};
	}

	const { title, description } = story.content?.metadata ?? {};

	const metadata = {
		title,
		noindex: story.content?.noindex,
		nofollow: story.content?.nofollow,
		description,
		language: story.lang,
		openGraph: extractOpenGraph(story),
		canonical: formatUrl(story.full_slug, true),
		metaTags: [
			{
				name: 'facebook-domain-verification',
				content: process.env.FACEBOOK_VERIFICATION_ID,
			},
		],
	};

	if (story.content.metadataImage?.image && story.images) {
		const image = getImage(story.content.metadataImage.filename, story.images);
		if (image) {
			metadata.image = formatUrl(image.publicURL, true, false);
		}
	}

	if (story.localizations) {
		metadata.languageAlternates = story.localizations.map(localization => ({
			hrefLang: localization.locale,
			href: formatUrl(localization.full_slug, true),
		}));
	}

	return metadata;
};
